module.exports = __webpack_public_path__ + "img/ARCTIC CAT.46ec6c3.jpg";